/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { IV1QuestionVariantSchema } from '../../entities/response/V1QuestionVariantSchema';
import { IV1ShortAnswerSchema } from '../../entities/request/V1ShortAnswerSchema';

export type TGetQuestionModel = IModel<IGetQuestionRequest, TGetQuestionResponse>;

export interface IGetQuestionRequest {
  /** Отсутствие означает, что запросили 1-й вопрос **/
  answer?: IV1ShortAnswerSchema | null;
  /** Id опросника **/
  quizId?: number | null;
  /** Поддомен **/
  subdomain: string;
}

export type TGetQuestionResponse = IGetQuestionResponse200 | IGetQuestionResponse400;

export interface IGetQuestionResponse200 extends IModelResponse<IGetQuestionResponse> {
  statusCode: 200;
}

export interface IGetQuestionResponse400 extends IModelResponse<IGetQuestionResponseError> {
  statusCode: 400;
}

export interface IGetQuestionResponse {
  /** Максимальная глубина дерева (для рисования прогресс бара) **/
  maxQuizLength: number;
  /** Id вопроса **/
  questionId: number;
  /** Тип **/
  questionType: EQuestionType;
  /** Шаг, на котором сейчас пользователь находится **/
  step: number;
  /** Текст вопроса **/
  title: string;
  /** Список вариантов ответа **/
  variants: IV1QuestionVariantSchema[];
}

export interface IGetQuestionResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IGetQuestionResponse | IGetQuestionResponseError;

export enum EQuestionType {
  /** Последний вопрос **/
  Last = 'last',
  /** Можно выбрать несколько вариантов ответа **/
  MultiChoice = 'multiChoice',
  /** Можно выбрать только 1 вариант ответа **/
  SingleChoice = 'singleChoice',
  /** Что-то пошло не так. Для пользователя приравнен к статусу последнего вопроса **/
  ThankYou = 'thankYou',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetQuestionResponse): TResponse200;
  400(response: IGetQuestionResponseError): TResponse400;
}
